<script setup>
/******************************************************************************
 * PageComponent: MeterRegister (Zählwerk) reading consumption
 *****************************************************************************/
import { formatReadingValue } from "@/handlers/useFormatting";
defineProps({
    consumption: {
        type: String,
        required: true,
    },
    unit: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <span>
        Verbrauch seit dem letzten Zählerstand
        <strong>{{ formatReadingValue(consumption) }}</strong> {{ unit }}
    </span>
</template>

<style lang="scss" scoped>
span {
    display: block;

    padding: #{get($sizes, "base") * 0.4};
    border: get($sizes, "border") solid get($client, "inputBorderColor");
    margin: #{get($sizes, "base") * 0.4} 0 0 0;

    border-radius: get($sizes, "radius");
}

strong {
    color: get($client, "meterReadingValueColor");

    font-weight: 400;
}
</style>
